///////////////////////////////////////////////////
//dl-header.js
///////////////////////////////////////////////////
class DL_HeaderFunc {
  constructor(selector) {
    console.log("DL_HeaderFunc");
    const header = this;
    header.body = document.querySelector(".dl-header");
    header.elements = document.querySelector(selector);
    header.nav = document.querySelectorAll(".dl-header__nav");
    header.navParent = document.querySelectorAll(
      ".dl-header__nav__li.has-child",
    );

    // 新規：対象セクション
    header.whiteSections = document.querySelectorAll(".js-headerWhite");
    header.transparentSections = document.querySelectorAll(
      ".js-headerTransparent",
    );
    if (header.navParent.length) {
      for (var i = 0; i < header.navParent.length; i++) {
        const parent = header.navParent[i];

        parent.addEventListener(
          "click",
          function (e) {
            if (DL_hasClass(this, "is-active")) {
              if (!e.target.closest(".dl-header__nav__child a")) {
                DL_removeClass(this, "is-active");
                DL_removeClass(header.body, "is-openPc");
                DL_removeClass(document.body, "is-headerchildopen");
              }
            } else {
              DL_removeClass(header.navParent, "is-active");
              DL_addClass(this, "is-active");
              DL_addClass(header.body, "is-openPc");
              DL_addClass(document.body, "is-headerchildopen");
            }
          },
          false,
        );

        parent.child = parent.querySelectorAll(
          ".dl-header__nav__child__li.has-child:not(.is-side)",
        );
        parent.childSide = parent.querySelector(
          ".dl-header__nav__child__li.has-child.is-side",
        );

        if (parent.child.length) {
          DL_addClass(parent.child[0], "is-active");
          parent.childWrap = parent.querySelector(
            ".dl-header__nav__child__wrap",
          );

          for (var j = 0; j < parent.child.length; j++) {
            const child = parent.child[j];
            child.child = child.querySelector(".dl-header__nav__child__child");

            child.addEventListener("mouseover", function (event) {
              DL_removeClass(parent.child, "is-active");
              DL_addClass(this, "is-active");
            });

            // child.addEventListener("mouseleave", function(event) {
            //   DL_removeClass(this, "is-active");
            // });
          }
        }
      }
    }

    window.addEventListener("resize", this.onResize.bind(this));
    window.addEventListener("scroll", this.onScroll.bind(this)); // 新規追加

    header.init();
    header.onScroll(); // 初期状態もチェック
  }

  init() {
    const header = this;
    if (header.navParent.length) {
      for (var i = 0; i < header.navParent.length; i++) {
        const parent = header.navParent[i];

        if (parent.child.length) {
          let maxH = 0;

          parent.childWrap.style.height = maxH + "px";
          for (var j = 0; j < parent.child.length; j++) {
            const child = parent.child[j];
            if (child.child.offsetHeight > maxH) {
              maxH = child.child.offsetHeight;
            }
          }

          if (parent.childSide) {
            if (parent.childSide.offsetHeight > maxH) {
              maxH = parent.childSide.offsetHeight;
            }
          }
          parent.childWrap.style.height = maxH + "px";
        }
      }
    }
  }

  onResize() {
    onWidthResize(({ width, height }) => {
      this.init();
      this.onScroll(); // リサイズ時にも状態を更新
    });
  }

  // onScroll() {
  //   const header = this;
  //   const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  //   const viewportMiddle = scrollTop + (window.innerHeight / 2);

  //   let isWhite = false;
  //   let isTransparent = false;

  //   // is-white チェック
  //   header.whiteSections.forEach(section => {
  //     const rect = section.getBoundingClientRect();
  //     const top = rect.top + scrollTop;
  //     const bottom = top + section.offsetHeight;
  //     if (viewportMiddle >= top && viewportMiddle <= bottom) {
  //       isWhite = true;
  //     }
  //   });

  //   // is-transparent チェック
  //   header.transparentSections.forEach(section => {
  //     const rect = section.getBoundingClientRect();
  //     const top = rect.top + scrollTop;
  //     const bottom = top + section.offsetHeight;
  //     if (viewportMiddle >= top && viewportMiddle <= bottom) {
  //       isTransparent = true;
  //     }
  //   });

  //   // クラスの切り替え
  //   if (isWhite) {
  //     DL_addClass(header.body, "is-white");
  //   } else {
  //     DL_removeClass(header.body, "is-white");
  //   }

  //   if (isTransparent) {
  //     DL_addClass(header.body, "is-transparent");
  //   } else {
  //     DL_removeClass(header.body, "is-transparent");
  //   }
  // }
  onScroll() {
    // console.log("onScroll");
    const header = this;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const headerHeight = header?.body?.offsetHeight ?? 0;
    // const borderLine = scrollTop + headerHeight * 0.5;
    const borderLine = scrollTop + headerHeight;

    let isWhite = false;
    let isTransparent = false;

    // .js-headerWhite の中に borderLine があるか判定
    header.whiteSections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      const top = scrollTop + rect.top - 60;
      const bottom = top + rect.height + 60;
      console.log({ scrollTop, section, rect, borderLine, top, bottom });
      if (borderLine >= top && borderLine <= bottom) {
        isWhite = true;
      }
    });

    // .js-headerTransparent の中に borderLine があるか判定
    header.transparentSections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      const top = scrollTop + rect.top;
      const bottom = top + rect.height;
      if (borderLine >= top && borderLine <= bottom) {
        isTransparent = true;
      }
    });

    // クラスの切り替え処理
    if (isWhite) {
      DL_addClass(header.body, "is-white");
    } else {
      DL_removeClass(header.body, "is-white");
    }

    if (isTransparent) {
      DL_addClass(header.body, "is-transparent");
    } else {
      DL_removeClass(header.body, "is-transparent");
    }
  }
}

new DL_HeaderFunc(".dl-header");

// class DL_HbgFunc {
//   constructor(selector) {
//     const hbg = this;
//     hbg.elements = document.querySelector(selector);
//     hbg.openFlg = false;
//     hbg.button = document.querySelector(".dl-js-hbgicon");
//     hbg.button.addEventListener(
//       "click",
//       function (e) {
//         if (hbg.openFlg) {
//           hbg.close();
//         } else {
//           hbg.open();
//         }
//       },
//       false
//     );

//     hbg.nav = document.querySelectorAll(".dl-header__hbgmenu__nav");
//     hbg.navParent = document.querySelectorAll(".dl-header__hbgmenu__nav__li.has-child");
//     if (hbg.navParent.length) {
//       // DL_addClass(hbg.navParent[0], "is-active");
//       DL_slideDown(hbg.navParent[0].querySelector(".dl-header__hbgmenu__nav__child"), 0);
//       for (var i = 0; i < hbg.navParent.length; i++) {
//         const parent = hbg.navParent[i];
//         parent.addEventListener(
//           "click",
//           function (e) {
//             if (!DL_hasClass(this, "is-large") && !DL_hasClass(this, "is-thumb")) {
//               if (!e.target.closest(".dl-header__hbgmenu__nav__child a")) {
//                 if (DL_hasClass(this, "is-active")) {
//                   DL_removeClass(this, "is-active");
//                   DL_slideUp(parent.querySelector(".dl-header__hbgmenu__nav__child"));
//                 } else {
//                   DL_addClass(this, "is-active");
//                   DL_slideDown(parent.querySelector(".dl-header__hbgmenu__nav__child"));
//                 }
//               }
//             }
//           },
//           false
//         );

//         parent.child = parent.querySelectorAll(".dl-header__hbgmenu__nav__child__li.has-child:not(.is-side)");
//         parent.childSide = parent.querySelector(".dl-header__hbgmenu__nav__child__li.has-child.is-side");
//         parent.childIdx = 0;
//         if (parent.child.length) {
//           // DL_addClass(parent.child[0], "is-active");
//           parent.childWrap = parent.querySelector(".dl-header__hbgmenu__nav__child__wrap");
//           for (var j = 0; j < parent.child.length; j++) {
//             parent.child[j].setAttribute("data-index", j);
//             const child = parent.child[j];
//             child.child = child.querySelector(".dl-header__hbgmenu__nav__child__child");
//             child.addEventListener(
//               "click",
//               function (e) {
//                 DL_removeClass(parent.child, "is-active");
//                 DL_addClass(this, "is-active");
//               },
//               false
//             );
//           }
//         }
//         let childClose = parent.querySelector(".child_close");
//         childClose.addEventListener(
//           "click",
//           function (e) {
//             e.stopPropagation(); // 最優先でバブリング止める
//             let activeLi = this.closest(".dl-header__hbgmenu__nav__child__li.has-child.is-active");
//             if (activeLi) {
//               DL_removeClass(activeLi, "is-active");
//             }
//           },
//           false
//         );
//       }
//     }

//     // hbg.open();
//   }
//   open() {
//     const hbg = this;
//     hbg.openFlg = true;
//     DL_addClass(hbg.button, "is-active");
//     DL_addClass(hbg.elements, "is-active");

//     document.body.style.overflow = "hidden";
//     // DL_fadeIn(hbg.elements, 200, function() {
//     //   document.body.style.overflow = "hidden";
//     // });
//   }
//   close() {
//     const hbg = this;
//     hbg.openFlg = false;
//     DL_removeClass(hbg.button, "is-active");
//     DL_removeClass(hbg.elements, "is-active");
//     document.body.style.overflow = "inherit";
//     // DL_fadeOut(hbg.elements, 200, function() {
//     //   // document.body.style.overflow = "hidden";
//     // });
//   }
// }

class DL_HbgFunc {
  constructor(selector) {
    const hbg = this;
    hbg.header = document.querySelector("header.dl-header");
    hbg.elements = document.querySelector(selector);
    hbg.openFlg = false;

    // ハンバーガーボタン
    hbg.button = document.querySelector(".dl-js-hbgicon");
    hbg.button.addEventListener("click", function () {
      hbg.openFlg ? hbg.close() : hbg.open();
    });

    hbg.nav = document.querySelectorAll(".dl-header__hbgmenu__nav");
    hbg.navParent = document.querySelectorAll(
      ".dl-header__hbgmenu__nav__li.has-child",
    );

    if (hbg.navParent.length) {
      // 最初の親メニューのサブメニューを開く（初期状態）
      DL_slideDown(
        hbg.navParent[0].querySelector(".dl-header__hbgmenu__nav__child"),
        0,
      );

      for (let i = 0; i < hbg.navParent.length; i++) {
        const parent = hbg.navParent[i];

        // ▼ 親liのクリックで is-active を切り替え
        parent.addEventListener("click", function (e) {
          if (e.target.closest(".child_close")) return; // child_close クリック時は無視

          if (
            !DL_hasClass(this, "is-large") &&
            !DL_hasClass(this, "is-thumb")
          ) {
            if (!e.target.closest(".dl-header__hbgmenu__nav__child a")) {
              if (DL_hasClass(this, "is-active")) {
                DL_removeClass(this, "is-active");
                DL_slideUp(
                  parent.querySelector(".dl-header__hbgmenu__nav__child"),
                );
              } else {
                DL_addClass(this, "is-active");
                DL_slideDown(
                  parent.querySelector(".dl-header__hbgmenu__nav__child"),
                );
              }
            }
          }
        });

        // ▼ 子要素（2階層目）の制御
        parent.child = parent.querySelectorAll(
          ".dl-header__hbgmenu__nav__child__li.has-child:not(.is-side)",
        );
        parent.childSide = parent.querySelector(
          ".dl-header__hbgmenu__nav__child__li.has-child.is-side",
        );
        parent.childIdx = 0;

        if (parent.child.length) {
          parent.childWrap = parent.querySelector(
            ".dl-header__hbgmenu__nav__child__wrap",
          );
          for (let j = 0; j < parent.child.length; j++) {
            parent.child[j].setAttribute("data-index", j);
            const child = parent.child[j];
            child.child = child.querySelector(
              ".dl-header__hbgmenu__nav__child__child",
            );

            // ▼ 子のクリックで is-active の切り替え
            child.addEventListener("click", function (e) {
              DL_removeClass(parent.child, "is-active");
              DL_addClass(this, "is-active");
            });

            // ▼ それぞれの child 内にある child_close を設定
            const childCloses = child.querySelectorAll(".child_close");
            childCloses.forEach((btn) => {
              btn.addEventListener("click", function (e) {
                e.stopPropagation();
                const activeLi = this.closest(
                  ".dl-header__hbgmenu__nav__child__li.has-child.is-active",
                );
                if (activeLi) {
                  DL_removeClass(activeLi, "is-active");
                }
              });
            });
          }
        }
      }
    }
    document
      .querySelectorAll(
        ".dl-header__hbgmenu__nav__child__li.has-child > .dl-header__hbgmenu__nav__child__link",
      )
      .forEach((link) => {
        link.addEventListener("click", function (e) {
          e.preventDefault();
          const li = this.closest(".dl-header__hbgmenu__nav__child__li");

          li.classList.toggle("is-active");

          // スクロール制御を更新
          hbg.updateMenuScrollLock(); // ← これが正解！
        });
      });
  }

  // メニューを開く
  open() {
    const hbg = this;
    hbg.openFlg = true;
    DL_addClass(hbg.button, "is-active");
    DL_addClass(hbg.elements, "is-active");
    DL_addClass(hbg.header, "is-openSp");
    document.body.style.overflow = "hidden";
  }

  // メニューを閉じる（is-active を全てクリア）
  close() {
    const hbg = this;
    hbg.openFlg = false;
    DL_removeClass(hbg.button, "is-active");
    DL_removeClass(hbg.elements, "is-active");
    DL_removeClass(hbg.header, "is-openSp");
    document.body.style.overflow = "inherit";

    // ▼ 追加：中の is-active を全て外す
    const activeEls = hbg.elements.querySelectorAll(
      ".dl-header__hbgmenu__nav__child__li.is-active",
    );
    activeEls.forEach((el) => el.classList.remove("is-active"));
  }
  updateMenuScrollLock() {
    const hbgWrap = document.querySelector(".dl-header__hbgmenu__wrap");
    const activeChild = hbgWrap.querySelector(
      ".dl-header__hbgmenu__nav__child__li.has-child.is-active .dl-header__hbgmenu__nav__child__child",
    );

    if (activeChild && getComputedStyle(activeChild).display !== "none") {
      hbgWrap.classList.add("is-child-active");
    } else {
      hbgWrap.classList.remove("is-child-active");
    }
  }
}
new DL_HbgFunc(".dl-header__hbgmenu");
